export const GET_APPLICATIONS_SITE_LIST_REQUEST = 'GET_APPLICATIONS_SITE_LIST_REQUEST';
export const GET_APPLICATIONS_SITE_LIST_SUCCESS = 'GET_APPLICATIONS_SITE_LIST_SUCCESS';
export const GET_APPLICATIONS_SITE_LIST_FAILURE = 'GET_APPLICATIONS_SITE_LIST_FAILURE';
export const SITE_SEARCH_REQUEST = 'SITE_SEARCH_REQUEST';
export const SITE_SEARCH_REQUEST_SUCCESS = 'SITE_SEARCH_REQUEST_SUCCESS';
export const SITE_SEARCH_REQUEST_FAILURE = 'SITE_SEARCH_REQUEST_FAILURE';
export const RESET_SITE_SEARCH_RESULT_REQUEST = 'RESET_SITE_SEARCH_RESULT_REQUEST';
// SGIP Message from Iframe
export const OPENING_EXISTING_APPLICATION = 'OPENING_EXISTING_APPLICATION';
export const CREATE_NEW_APPLICATION = 'CREATE_NEW_APPLICATION';
